<template>
  <div>
    <SideBar :bar_name="`Chang TT ${tabName}`" :user="user"></SideBar>
    <v-main>
      <v-container>
        <Reward v-bind="{ user, tabName }" />
      </v-container>
    </v-main>
  </div>
</template>

<script>
import SideBar from "@/components/SideBar";
import Reward from "@/components/ChangTT/Reward";

export default {
  name: "CTTReward",
  components: {
    SideBar,
    Reward,
  },
  data() {
    return {
      user: this.$user,
      tabName: "Reward",
    };
  },
};
</script>
